<template>
  <div
    :data-testid="`remark-group-container-${name}`"
    class="tw-bg-gray-100 tw-rounded-lg remark-group"
  >
    <div
      class="
        tw-flex
        tw-flex-row
        tw-justify-between
        tw-align-center
        tw-py-4
        tw-px-6
        tw-sticky
        tw-bg-gray-100
        tw-rounded-lg
        tw-z-40
        remark-group--header
      "
      :data-testid="`remark-group-${name}`"
    >
      <span class="tw-flex tw-flex-row tw-align-baseline">
        <i
          data-testid="remark-group-toggle"
          class="tw-text-xs tw-w-6 tw-p-1 tw-text-center tw-cursor-pointer fa"
          :class="expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
          @click="toggleExpanded"
        />
        <span class="tw-text-base tw-font-medium">{{ name }}</span>
      </span>
      <span>
        <span
          class="
            tw-uppercase tw-font-medium tw-text-xs tw-text-sf-gray-dark tw-p-2
          "
        >
          <span data-testid="message-count-indicator">
            <slot name="message-count-indicator" />
          </span>
        </span>
        <SfButtonInverted
          v-if="showMarkAsRead"
          small
          inline
          variant="dark"
          :disabled="disableMarkAsRead"
          :data-heap="markAsReadHeapTag"
          @click="emit('markAsRead')"
        >
          <span
            data-testid="remark-group-mark-as-read"
            class="
              tw-flex tw-flex-row tw-items-center tw-align-baseline tw-gap-2
            "
          >
            <i class="fa fa-envelope-open" />
            {{ I18n.t('communication.inbox.mark_as_read') }}
          </span>
        </SfButtonInverted>
      </span>
    </div>
    <div v-if="expanded" class="tw-flex tw-flex-col tw-px-6 tw-pb-6 tw-gap-4">
      <slot name="default" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import SfButtonInverted from '@app/shared/vue/components/sf-button/sf-button-inverted.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

const emit = defineEmits<{ markAsRead: []; toggled: [boolean] }>()

interface Props {
  disableMarkAsRead?: boolean
  showMarkAsRead?: boolean
  initiallyOpened?: boolean
  markAsReadHeapTag?: string
  name: string
}

const props = withDefaults(defineProps<Props>(), { initiallyOpened: true })

const expanded = ref<boolean>(props.initiallyOpened)
function toggleExpanded() {
  expanded.value = !expanded.value
  emit('toggled', expanded.value)
}

const I18n = useI18n()
</script>

<style scoped>
.remark-group--header {
  top: var(--sf-remark-group-sticky-offset);
}
</style>
